export default __webpack_public_path__ + "static/media/profit.75f1409b.png";